import {
  addNoBreakSpaces,
  formatNumberAsCurrency,
  isString,
} from '@/utils';

type TOptions = { symbol?: string, float?: boolean };
type TValue = number | string;
type TFormatNumericValueToDisplay = (value: TValue, options?: TOptions) => string | number;

/**
 * Возвращает отформатированное числовое значение. Если после запятой есть цифры,
 * то выводит с 2 знаками после запятой, округляя до сотых.
 * Если после запятой нет ничего, то выводит целое число.
 */
const formatNumericValueToDisplay: TFormatNumericValueToDisplay = (
  value: TValue,
  { symbol = '', float = false }: TOptions = {
    symbol: '',
    float: false,
  }) => {
  if (!value && value !== 0) return value;

  let numberValue: number;
  if (isString(value)) {
    numberValue = Number(value.replace(',', '.'));
  } else {
    numberValue = Number(value);
  }
  if (Number.isNaN(numberValue)) return value;

  const hasFloat = float || (numberValue % 1) > 0;

  const currency: string = formatNumberAsCurrency(
    numberValue,
    hasFloat ? 2 : 0,
    {
      separator: ' ',
      decimal: ',',
      symbol,
    },
  );

  return addNoBreakSpaces(currency);
};

export default formatNumericValueToDisplay;
